"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAssetUpload = void 0;
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledAssetUpload = (0, styled_components_1.default)(antd_1.Upload) `
	width: auto;
	.ant-upload-select-picture-card {
		width: 245px;
		height: 245px;
		border-radius: ${props => props.theme.borderRadius.large};
	}
`;
